hrd.utils.CacheProvider = hrd.Class.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.utils.CacheProvider',
			defaultOptions: {
				type: 'DDP', //'DTP = DataTableProvider', 'DDP = DropDownProvider', 'JP: JsonProvider', 'ACTION: json crud invocation', 'REST: REST service'
				url: undefined,
				sProvider: undefined,
				sMethod: undefined,
				httpMethod: 'GET',
				input: {},
				settings: {}
			}

		};
		this._super($.extend({}, defaults, options));
		this.toolbox = new hrd.Toolbox();
		this.cache = {};
	},
	provide: function(cacheKey, options) {
		options = $.extend({}, this.settings.defaultOptions, options);
		if (this.cache[cacheKey] == undefined) {
			switch (options.type) {
				case 'DTP':
					this.cache[cacheKey] = dashboardInstance.invokeDataTable(options.sProvider, options.input, options.settings);
					break;
				case 'DDP':
					this.cache[cacheKey] = dashboardInstance.invokeDataTable(options.sProvider, options.input, options.settings)
						.then(table => this.toolbox.get('aaData', table, []));
					break;
				case 'JP':
					if (sMethod != undefined) {
						this.cache[cacheKey] = dashboardInstance.invokeProvider(options.sProvider, options.sMethod, options.input, options.settings);
					} else {
						this.cache[cacheKey] = dashboardInstance.invokeSimpleProvider(options.sProvider, options.input, options.settings);
					}
					break;
				case 'ACTION':
					this.cache[cacheKey] = dashboardInstance.invokeActionURI(options.url, options.input);
					break;
				case 'REST':
					this.cache[cacheKey] = dashboardInstance.invokeRest(options.path, options.input, options.httpMethod);
					break;
			}
			this.cache[cacheKey].fail(_ => this.invalidate(cacheKey))
		}
		return this.cache[cacheKey] != undefined ? this.cache[cacheKey] : $.never();
	},
	invalidate: function(cacheKey) {
		this.cache[cacheKey] = undefined;
	}
});